<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="tabnavs">
						<el-tabs v-model="activeName"  @tab-click="handleClick">
							<el-tab-pane label="基本资料" name="/setting"></el-tab-pane>
							<el-tab-pane label="实名认证" name="/real"></el-tab-pane>
							<el-tab-pane label="密码管理" name="/passWord"></el-tab-pane>
							<el-tab-pane label="手机设置" v-if="userList.phone" name="/updatePhone"></el-tab-pane>
							<el-tab-pane label="绑定手机" v-if="!userList.phone" name="/bindPhone"></el-tab-pane>
							<el-tab-pane label="提现账号" name="/withdrawAccount"></el-tab-pane>
						</el-tabs>
					</div>

					<div class="box tab-content">
						<div class="userform">
							<div class="divider">
								<div class="form-group">
									<label class="form-label">用户ID：</label>
									<div class="form-element">
										<p>{{userList.user_id}}</p>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">真实姓名：</label>
									<div class="form-element">
										{{userList.is_real === 0 && userList.is_advanced===0?"未知":userList.is_real===1&&userList.is_advanced===0?name:userList.is_real === 1&&userList.is_advanced===1?name:"未知"}}
										<span class="label" :class="userList.is_real === 0 && userList.is_advanced===0?'label-default':userList.is_real===1&&userList.is_advanced===0?'label-warnin':userList.is_real === 1&&userList.is_advanced===1?'label-primary':'label-primary'">{{userList.is_real === 0 && userList.is_advanced===0?"实名认证":userList.is_real===1&&userList.is_advanced===0?"已初级实名":userList.is_real === 1&&userList.is_advanced===1?"已完成实名":"实名认证"}}</span>
										<span class="sep">|</span>
										<a class="text-blue" href="javascript:;" @click="openReal()">{{userList.is_real === 0 && userList.is_advanced===0?"去实名":userList.is_real===1&&userList.is_advanced===0?'去高级实名':userList.is_real === 1&&userList.is_advanced===1?'查看':"去实名"}}</a>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">手机绑定：</label>
									<div class="form-element">
										<p>
										{{$fxLink.checkHide(userList.phone)}}
										<span class="sep">|</span>
										<a href="javascript:;" class="text-blue" @click="openPhone()">{{userList.phone?'更换手机':"去绑定"}}</a>
										</p>
									</div>
								</div>
                <div class="form-group" v-if="userList.is_check != 1">
                	<label class="form-label">尽职调查：</label>
                	<div class="form-element">
                		<p>
                		{{inquiry && inquiry.status === 1?'已填写':'未填写'}}
                		<span class="sep">|</span>
                		<a href="javascript:;" class="text-blue" @click="openSurvey()">前往填写</a>
                		</p>
                	</div>
                </div>
								<div class="form-group">
									<label class="form-label">退出登录：</label>
									<div class="form-element">
										<p  >
											<a class="text-red" href="javascript:;" @click="$commonJs.getOut()">退出登录</a>


										</p>

									</div>
								</div>
							</div>
						</div>
					</div>
          <el-dialog  :visible.sync="dialogVisible" title="" width='522px' custom-class="pop-radius">
          	<div class="userform" style="padding: 0;">
              <div class="text-center">
                <div v-if="inquiry.status === 0" class="alcenter flex-center">
                	<el-icon class="waring-wds ft25"><InfoFilled /></el-icon>
                	<span class="ft20 ml16">审核中</span>
                </div>
                <div v-if="inquiry.status === 1" class="alcenter flex-center">
                	<el-icon class="success-wds ft25"><SuccessFilled /></el-icon>
                	<span class="ft20 ml16">审核成功</span>
                </div>
                <div v-if="inquiry.status === 2 || inquiry.status === 3" class="alcenter flex-center">
                	<el-icon class="error-wds ft25"><WarningFilled /></el-icon>
                	<span class="ft20 ml16">{{inquiry.status === 2?'可重新提交':"审核驳回"}}</span>
                </div>
                <div v-if="inquiry.status === 4" class="alcenter flex-center">
                	<el-icon class="error-wds ft25"><CircleCloseFilled /></el-icon>
                	<span class="ft20 ml16">审核失败</span>
                </div>
                <div class="ft18 c_909399 mt24">
                	<p v-if="inquiry.status === 3 || inquiry.status===2">{{inquiry.cause}}</p>
                	<p v-else>{{inquiry.status === 0?'请耐心等待人工审核':inquiry.status===1?'已完成尽职调查':''}}</p>
                </div>
                <div class="  text-center" >
                  <button class="btn btn-primary btn-sm btn-square px30" style="width: 200px;margin-top: 20px;" v-if="inquiry.status === 2"  @click="oepnSurvey()">重新提交</button>
                  <button class="btn btn-default btn-sm btn-square px30" style="width: 200px;margin-top: 20px;"  @click="dialogVisible = false;">关闭</button>
                </div>
              </div>
          	</div>
          	<template #footer>
          		<span class="dialog-footer">
          		</span>
          	</template>
          </el-dialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				userList:[],
				name:"",
				activeName:"/setting",
        inquiry:{},
        dialogVisible:false
			}
		},
		created() {
			this.activeName =  window.location.hash.replace(/[#]/g, '')
			this.getUser()
			this.getUserRealStatus()
		},
		methods:{

      loadDetail3(){
        return new Promise((resolve,reject) => {
          let user_id = JSON.parse(localStorage.getItem("userInfo")).user_id
          this.$api.dueDiligenceStatus({
            user_id,
          })
          .then(result => {
            if(result.code === 1){
              this.inquiry = result.data
            }else{
              this.inquiry = {}
            }
            resolve(result.data)
          })
        })
      },
      oepnSurvey(){
        console.log(5645456456)
      	this.$router.push({path:'/survey'})
      },
      async openSurvey(){
        this.inquiry = await this.loadDetail3()
        if(!this.inquiry){
          this.inquiry = {}
          this.inquiry['status']= null
        }
        if(this.inquiry.status === null){
          this.oepnSurvey()
        }else{
          console.log('dasdasd')
          if(this.inquiry.status === 1){
            return
          }
          this.dialogVisible = true
        }
      },
			openReal(){

			},
			openPhone(){
				if(this.userList.phone){
					this.$router.push({ path:'/updatePhone'})
				}else{
					this.$router.push({ path:'/bindPhone'})
				}
			},
			handleClick(tab, event) {
				this.$router.push({ path:this.activeName})
			},
			getUser(){
				let token = localStorage.getItem('token')
				this.$api.userInfo({
					token
				}).then(result => {
					if(result.code === 1){
						localStorage.setItem("userInfo",JSON.stringify(result.data))
						this.userList = result.data
            if(this.userList.is_check != 1){
            	this.loadDetail3()
            }
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			// 实名信息
			getUserRealStatus(){
				let token = localStorage.getItem('token')
				this.$api.getUserRealStatus({
					token:token,
					type:1
				}).then(res => {
					if(res.code === 1){
						if(res.data.name){
							this.name = res.data.name
						}
					}
				})
			},
		}
	}
</script>

<style scoped>
  .ft20{
    font-size: 20px;
  }
  .flex-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .c_909399{
    color: #909399;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/setting/setting.vue